(() => {
  const getStrings = () => (window.gwaStrings && window.gwaStrings.tutorial_article) || {};
  const escapeAttr = (value) =>
    String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  document.addEventListener('DOMContentLoaded', () => {
    const S = getStrings();
    const normalizeImportedBlocks = (content) => {
      const blocks = Array.from(content.querySelectorAll(':scope > [data-tutorial-block]'));
      let gallery = null;

      blocks.forEach((block) => {
        block.querySelectorAll('p').forEach((paragraph) => {
          const hasMedia = paragraph.querySelector('img, picture, iframe, video');
          if (!hasMedia && !paragraph.textContent.replace(/\u00a0/g, ' ').trim()) paragraph.remove();
        });

        const media = block.querySelector(':scope > .tutorialArticle__blockMedia');
        const textElements = Array.from(block.children).filter((element) => element !== media);
        const hasText = textElements.some((element) => element.textContent.replace(/\u00a0/g, ' ').trim());

        if (!hasText && !media) {
          block.remove();
          return;
        }

        if (!hasText) {
          block.classList.add('tutorialArticle__block--mediaOnly');

          if (!gallery) {
            gallery = document.createElement('div');
            gallery.className = 'tutorialArticle__imageGallery';
            block.before(gallery);
          }
          gallery.appendChild(block);
          return;
        }

        if (!media && textElements.length === 1 && /^H[1-6]$/.test(textElements[0].tagName)) {
          block.classList.add('tutorialArticle__block--titleOnly');
        }

        gallery = null;
      });

      Array.from(content.children).forEach((block) => {
        if (!block.matches('[data-tutorial-block]')) return;

        const media = block.querySelector(':scope > .tutorialArticle__blockMedia');
        const nextGallery = block.nextElementSibling;
        if (!media || !nextGallery?.classList.contains('tutorialArticle__imageGallery')) return;

        const galleryItem = document.createElement('section');
        galleryItem.className = 'tutorialArticle__block tutorialArticle__block--mediaOnly';
        galleryItem.appendChild(media);
        nextGallery.prepend(galleryItem);
      });

      content.querySelectorAll('.tutorialArticle__imageGallery').forEach((imageGallery) => {
        const imageCount = imageGallery.children.length;

        if (imageCount === 1) {
          imageGallery.classList.add('tutorialArticle__imageGallery--single');
        }

        if (imageCount <= 3) return;

        imageGallery.classList.add('tutorialArticle__imageGallery--slider');
        imageGallery.setAttribute('aria-label', S.image_gallery || 'Bildergalerie');
        imageGallery.setAttribute('role', 'region');

        const controls = document.createElement('div');
        controls.className = 'tutorialArticle__galleryControls';
        const previous = document.createElement('button');
        const next = document.createElement('button');

        previous.type = 'button';
        previous.className = 'tutorialArticle__galleryButton tutorialArticle__galleryButton--previous';
        previous.setAttribute('aria-label', S.previous_images || 'Vorherige Bilder');
        previous.innerHTML = '<span aria-hidden="true">&larr;</span>';
        next.type = 'button';
        next.className = 'tutorialArticle__galleryButton tutorialArticle__galleryButton--next';
        next.setAttribute('aria-label', S.next_images || 'Nächste Bilder');
        next.innerHTML = '<span aria-hidden="true">&rarr;</span>';

        const scrollByPage = (direction) => {
          imageGallery.scrollBy({
            left: direction * imageGallery.clientWidth,
            behavior: 'smooth',
          });
        };

        previous.addEventListener('click', () => scrollByPage(-1));
        next.addEventListener('click', () => scrollByPage(1));
        controls.append(previous, next);
        imageGallery.after(controls);
      });
    };

    const setupImageLightbox = (content) => {
      const galleries = Array.from(content.querySelectorAll('.tutorialArticle__imageGallery'));
      if (!galleries.length) return;

      const dialog = document.createElement('dialog');
      dialog.className = 'tutorialArticle__lightbox';
      dialog.innerHTML = `
        <div class="tutorialArticle__lightboxFrame">
          <button type="button" class="tutorialArticle__lightboxClose" aria-label="${escapeAttr(S.close_lightbox || 'Bildansicht schließen')}"><svg class="icon icon-close" viewBox="0 0 18 17" aria-hidden="true"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg></button>
          <button type="button" class="tutorialArticle__lightboxNav tutorialArticle__lightboxNav--previous" aria-label="${escapeAttr(S.previous_image || 'Vorheriges Bild')}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H5M5 12L12 5M5 12L12 19"/></svg></button>
          <img class="tutorialArticle__lightboxImage" alt="">
          <button type="button" class="tutorialArticle__lightboxNav tutorialArticle__lightboxNav--next" aria-label="${escapeAttr(S.next_image || 'Nächstes Bild')}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H5M5 12L12 5M5 12L12 19"/></svg></button>
          <p class="tutorialArticle__lightboxCount" aria-live="polite"></p>
        </div>
      `;
      document.body.appendChild(dialog);

      const lightboxImage = dialog.querySelector('.tutorialArticle__lightboxImage');
      const count = dialog.querySelector('.tutorialArticle__lightboxCount');
      const previous = dialog.querySelector('.tutorialArticle__lightboxNav--previous');
      const next = dialog.querySelector('.tutorialArticle__lightboxNav--next');
      let images = [];
      let activeIndex = 0;

      const render = () => {
        const image = images[activeIndex];
        lightboxImage.src = image.currentSrc || image.src;
        lightboxImage.alt = image.alt || '';
        const hasMultiple = images.length > 1;
        previous.hidden = !hasMultiple;
        next.hidden = !hasMultiple;
        count.hidden = !hasMultiple;
        count.textContent = hasMultiple ? `${activeIndex + 1} / ${images.length}` : '';
      };

      const open = (gallery, image) => {
        images = Array.from(gallery.querySelectorAll('.tutorialArticle__blockImg'));
        activeIndex = Math.max(images.indexOf(image), 0);
        render();
        dialog.showModal();
      };

      previous.addEventListener('click', () => {
        activeIndex = (activeIndex - 1 + images.length) % images.length;
        render();
      });
      next.addEventListener('click', () => {
        activeIndex = (activeIndex + 1) % images.length;
        render();
      });
      dialog.querySelector('.tutorialArticle__lightboxClose').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      galleries.forEach((gallery) => {
        gallery.querySelectorAll('.tutorialArticle__blockImg').forEach((image) => {
          image.classList.add('tutorialArticle__blockImg--zoomable');
          image.tabIndex = 0;
          image.setAttribute('role', 'button');
          const imageName = image.alt || S.image || 'Bild';
          image.setAttribute(
            'aria-label',
            S.zoom_image ? S.zoom_image.replace('__ALT__', imageName) : `${imageName} vergrößern`
          );
          image.addEventListener('click', () => open(gallery, image));
          image.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              open(gallery, image);
            }
          });
        });
      });
    };

    document.querySelectorAll('[data-tutorial-article]').forEach((root) => {
      const articleGrid = root.querySelector('.tutorialArticle__articleGrid');
      const media = root.querySelector('.tutorialArticle__mainMedia');
      const sidebar = articleGrid?.querySelector('.tutorialArticle__course');

      if (articleGrid && media && sidebar) {
        const syncSidebarHeight = () => {
          articleGrid.style.setProperty('--tutorial-hero-media-height', `${media.offsetHeight}px`);
        };

        syncSidebarHeight();
        new ResizeObserver(syncSidebarHeight).observe(media);
      }

      const content = root.querySelector('[data-tutorial-content]');
      const toc = root.querySelector('[data-tutorial-toc]');
      if (!content) return;

      normalizeImportedBlocks(content);
      setupImageLightbox(content);
      if (!toc) return;

      const headings = Array.from(content.querySelectorAll('h3, h4, h5, h6')).filter((heading) => heading.textContent.trim());
      if (!headings.length) {
        const box = toc.closest('.tutorialArticle__toc');
        if (box) box.style.display = 'none';
        return;
      }

      headings.forEach((heading, index) => {
        const text = heading.textContent.trim();
        if (!heading.id) heading.id = `tutorial-section-${index + 1}`;

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = text;
        item.className = 'is-sub';
        item.appendChild(link);
        toc.appendChild(item);
      });
    });
  });
})();
